export default function ContactSection() {
  return (
    <section id="contact" className="py-28 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-500 text-xs font-semibold uppercase tracking-[0.3em] mb-4">
            / Get In Touch
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Contact Us
          </h2>
          <p className="text-gray-400 text-base mt-4 max-w-md mx-auto">
            Have a question or want to reach our team? Here&apos;s everything you need to get in touch with us.
          </p>
        </div>

        {/* Contact Card */}
        <div className="bg-[#0F0F0F] rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left: Image */}
            <div className="relative h-[300px] lg:h-auto min-h-[400px]">
              <img
                src="https://public.readdy.ai/ai/img_res/1d6f6d9f8a33fdc279b45d2a1defc2ad.jpg"
                alt="DUGAN d.o.o. office"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0F0F0F]/60 lg:bg-gradient-to-r lg:from-transparent lg:to-[#0F0F0F]"></div>
              {/* Overlay Content */}
              <div className="absolute bottom-8 left-8">
                <div className="flex items-center gap-3">
                  <img
                    src="https://public.readdy.ai/ai/img_res/a31af569-c992-4171-83c9-227e57bb06c8.png"
                    alt="DUGAN d.o.o. logo"
                    className="w-10 h-10 object-contain"
                  />
                  <span className="text-white font-bold text-lg">DUGAN d.o.o.</span>
                </div>
              </div>
            </div>

            {/* Right: Contact Info */}
            <div className="p-10 md:p-14 flex flex-col justify-center">
              <h3 className="text-white text-2xl font-bold mb-10">Contact Information</h3>

              <div className="space-y-7">
                {/* Address */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 flex-shrink-0">
                    <i className="ri-map-pin-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Address</p>
                    <p className="text-white text-base font-medium">Trakoscanska 24</p>
                    <p className="text-white/70 text-sm mt-0.5">
                      City: Varazdin &nbsp;|&nbsp; Zip: 42000 &nbsp;|&nbsp; Country: Croatia
                    </p>
                  </div>
                </div>

                {/* Divider */}
                <div className="border-t border-white/10"></div>

                {/* Email */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 flex-shrink-0">
                    <i className="ri-mail-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Email</p>
                    <p className="text-white text-base font-medium">help@dugandoo.com</p>
                  </div>
                </div>

                {/* Divider */}
                <div className="border-t border-white/10"></div>

                {/* Phone */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 flex-shrink-0">
                    <i className="ri-phone-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Phone Number</p>
                    <p className="text-white text-base font-medium">+1 5186348020</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bar */}
        <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} DUGAN d.o.o. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-gray-400 text-sm">
            <span>iOS App Development</span>
            <span className="w-1 h-1 rounded-full bg-gray-300"></span>
            <span>Croatia</span>
          </div>
        </div>
      </div>
    </section>
  );
}
